import React, { ReactNode } from 'react'
import { Tooltip } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'
import { getClassNames } from '../../_utils/classnames'

import './info-tooltip.scss'

type InfoTooltipProps = {
    /** The explanation. Also the trigger's accessible name, when it is a string. */
    title: ReactNode
    /** What the explanation is about, for the trigger's name when the title is not a string. */
    about?: string
    className?: string
}

/**
 * An explanation hung off an info icon.
 *
 * A real button rather than a styled icon: content that appears only on hover is
 * unreachable by anyone not using a pointer, and Ant Design's icons render as a
 * `span[role=img]` that takes neither focus nor a name. A button both takes
 * focus — which is what opens the tooltip for a keyboard — and can say what it
 * is about before it is opened.
 */
export const InfoTooltip = ({ title, about, className }: InfoTooltipProps) => {
    const name = about ?? (typeof title === 'string' ? title : undefined)

    return (
        <Tooltip classNames={{ root: getClassNames('app-message-builder-tip') }} title={title}>
            <button
                type="button"
                className={getClassNames('info-tooltip', className)}
                aria-label={name ? `More information: ${name}` : 'More information'}
            >
                <InfoCircleOutlined aria-hidden="true" />
            </button>
        </Tooltip>
    )
}
